import { MouseEvent, useEffect, useState } from "react";
import { useTabsStore } from "../../stores/TabsStore";
import { t } from "i18next";
import { Button } from "../../ui/Button";
import { TbBuildingFactory2, TbContainer, TbTrash, TbUsersGroup } from "react-icons/tb";
import { Separator } from "../../ui/Separator";
import { getBaseTemplateForTabType } from "../../components/Templates/templates";
import { useFetch } from "../../hooks/useFetch";
import { CustomReport } from "../../types/types";
import { DateTime } from "luxon";
import { base_reports } from "../../enums/reports";

type Props = {};



const ReportsHome = (props: Props) => {
  const {setActiveReport} = useTabsStore();
  const [search, setSearch] = useState("");
  const [reportData, setReportData] = useState<{name: string, title: string}>();
  const [reportToDelete, setReportToDelete] = useState<{name: string, title: string}>();
  const [reportsList, setReportsList] = useState<{name: string, title: string}[]>();
  const [{ response: listPesponse, isLoading: listIsLoading, error: listError }, doFetchListReport] = useFetch(
    `/directories/custom_data_storages`
  );

  useEffect(() => {
    doFetchListReport();
  }, []);

  useEffect(() => {
    if (!listPesponse) return
    const list = listPesponse.data as unknown as { name: string; title: string }[];
    setReportsList(list);
  }, [listPesponse]);

  const [{ response, isLoading }, doFetchReport] = useFetch(`/directories/custom_data_storages/${reportData?.name}`);
  const [{ response: deletePesponse, isLoading: deleteIsLoading }, doDeleteReport] = useFetch(
    `/directories/custom_data_storages/${reportToDelete?.name}`
  );

  useEffect(() => {
    if (!reportToDelete) return;

    doDeleteReport({
      method: "DELETE",
    });
  }, [reportToDelete]);

  useEffect(() => {
    if (!deletePesponse || !reportToDelete) return;

    setReportsList(reportsList?.filter((localReport) => localReport.name != reportToDelete.name));
    setReportToDelete(undefined);
  }, [deletePesponse]);

  const handleSearch = (event: any) => {
    setSearch(event.target.value);
  };

  function addReport(report: any) {
    setActiveReport({name: report.type, title: report.type === "equipments" ? t('report_by_equipments') : t('report_by_persons')})
  }

  const getReport = (report: { name: string; title: string }) => {
    setActiveReport(report)
    // setReportData(report);
    // doFetchReport();
  };

  const deleteReport = (
    e: MouseEvent<HTMLButtonElement, globalThis.MouseEvent>,
    report: { name: string; title: string }
  ) => {
    e.stopPropagation();
    setReportToDelete(report);
  };


  return (
    <div className="max-w-[1200px] mx-auto w-full mt-10">
      <div className="grid grid-cols-3 gap-4">
        {base_reports.map((report) => (
          <div key={report.name} className="flex flex-col gap-2 border rounded-sm p-4">
            <div className="flex h-10 justify-between items-center">
              <span className="text-lg font-semibold">{report.name}</span>
              {report.icon}
            </div>
            <span className="text-sm mb-4">{report.desc}</span>
            <Button type="button" className="w-24" variant="default" size="md" onClick={() => addReport(report)}>
              {t("create")}
            </Button>
          </div>
        ))}
      </div>

      <div className="w-full mt-8">
        <span className="text-sm font-semibold leading-8">{t("list_of_saved_reports")}</span>
        <Separator />
        {listIsLoading ? (
          <div className="text-sm py-2">{t("loading")}</div>
        ) : listError ? (
          <div className="text-sm py-2 text-red-600">
            {listError.errors?.map((err: any) => err.detail || err.title).filter(Boolean).join(", ") || t("error")}
          </div>
        ) : reportsList && reportsList.length > 0 ? (
          <div className="-mx-2 mt-2 gap-2">
            {reportsList.map((report) => (
              <div key={report.name} className="hover:bg-secondary px-2 cursor-pointer rounded" onClick={() => getReport(report)}>
                <div className="flex justify-between items-center text-sm font-medium py-1">
                  <div>{report.title} - {report.name}</div>
                  <Button type="button" variant="ghost" size="md" onClick={(e) => deleteReport(e, report)}>
                    <TbTrash size={18}/>
                  </Button>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="text-sm py-2">{t("no_data")}</div>
        )}
      </div>
    </div>
  );
};

export default ReportsHome;
